export default function SegmentsSection() {
  const segments = [
    {
      icon: 'ri-building-line',
      title: 'Engenharia e Obras'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Serviços Ambientais'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Equipamentos Médicos'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Eventos e Estruturas'
    }
  ];

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5544999957005?text=Olá!%20Gostaria%20de%20consultar%20a%20viabilidade%20do%20meu%20segmento%20para%20licitações.', '_blank');
  };

  return (
    <section className="py-20 bg-light-grey">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Alguns Segmentos Onde Já Atuamos
          </h2>
          <p className="text-lg text-text-grey max-w-3xl mx-auto">
            Atendemos empresas de diversos setores. Veja alguns exemplos de áreas onde nossa equipe já conquistou licitações:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {segments.map((segment, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-lg hover:shadow-xl transition-all duration-300 group cursor-pointer text-center"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-primary rounded-full mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
                <i className={`${segment.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-primary">
                {segment.title}
              </h3>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-text-grey italic text-lg mb-6 max-w-2xl mx-auto">
            Sua área não está na lista? Não tem problema! Atendemos todos os segmentos que participam de licitações públicas.
          </p>
          <button
            onClick={handleWhatsAppClick}
            className="px-8 py-4 bg-white text-primary font-semibold rounded-lg border-2 border-primary hover:bg-primary hover:text-white transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Consultar Viabilidade
          </button>
        </div>
      </div>
    </section>
  );
}